import React, { Fragment } from 'react';

const Navigation = ({ links = [], contentLink = null, level = 1 }) => {
  let menuRef = React.createRef();
  let menuTriggerRef = React.createRef();
  function toggleMenu() {
    if (menuRef && menuRef.current) {
      menuRef?.current.classList.toggle('navbar__menu--show');
      if (menuTriggerRef.current) {
        menuTriggerRef.current.classList.toggle('menu--open');
      }
      if (isTopLevel) {
        document.body.classList.toggle('menu--open');
      } else {
        document.body.classList.toggle(`menu--lvl${level}`);
      }
    }
  }
  function mouseEnter() {
    menuRef.current.classList.add('menu-hovered');
  }
  function mouseLeave() {
    menuRef.current.classList.remove('menu-hovered');
  }
  const isTopLevel = level == 1;
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;
  const menuModeClass = links.length > 6 ? 'masontry-mode' : '';

  return (
    <Fragment>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          ref={menuTriggerRef}
          onClick={toggleMenu}
        ></a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${selectedClass} ${additionClass || ''}`}
            href={contentLink.url || '#'}
            dangerouslySetInnerHTML={{
              __html: contentLink.name,
            }}
          ></a>
          {links.length > 0 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <ul className={`navbar__menu ${menuModeClass}`} ref={menuRef}>
          {!isTopLevel && (
            <div className="navbar__menu-header">
              {!contentLink ? (
                <span
                  className="navbar__icon navbar__icon--close"
                  onClick={toggleMenu}
                ></span>
              ) : (
                <Fragment>
                  <i
                    className="navbar__icon--caret-left navbar__icon"
                    onClick={toggleMenu}
                  ></i>
                  <span
                    className="navbar__title"
                    onClick={toggleMenu}
                    dangerouslySetInnerHTML={{
                      __html: contentLink.name,
                    }}
                  ></span>
                </Fragment>
              )}
            </div>
          )}
          {links.length > 0 &&
            links.map((link, i) =>
              hasNameOrChildren(link) && isTopLevel && link.links.length > 0 ? (
                <li
                  className={`navbar__item has-children ${
                    links.length == i + 1 ? 'last' : ''
                  }`}
                  key={i}
                  onMouseOver={mouseEnter}
                  onMouseOut={mouseLeave}
                >
                  <Navigation
                    links={link.links}
                    contentLink={link}
                    level={level + 1}
                  />
                </li>
              ) : (
                <li
                  className={`navbar__item ${
                    link.links.length > 0 ? 'has-children' : ''
                  } ${links.length == i + 1 ? 'last' : ''}`}
                  key={i}
                >
                  <Navigation
                    links={link.links}
                    contentLink={link}
                    level={level + 1}
                  />
                </li>
              )
            )}
        </ul>
      )}

      {isTopLevel && <div className="navbar__backdrop"></div>}
    </Fragment>
  );
};

export default Navigation;
